import { render, staticRenderFns } from "./subIndex.vue?vue&type=template&id=05517f52&scoped=true&"
import script from "./subIndex.vue?vue&type=script&lang=js&"
export * from "./subIndex.vue?vue&type=script&lang=js&"
import style0 from "./subIndex.vue?vue&type=style&index=0&id=05517f52&prod&lang=css&"
import style1 from "./subIndex.vue?vue&type=style&index=1&id=05517f52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05517f52",
  null
  
)

export default component.exports